var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "62px",
    viewBox: "0 0 69 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A56726E-213D-475B-86BD-D56CBA3E0EE0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-Key-Facts-about-Hana",
    transform: "translate(-353.000000, -645.000000)",
    strokeWidth: 2.43345
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(355.000000, 647.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,51 C11.4165578,51 0,39.5832978 0,25.500093 C0,11.4167022 11.4165578,0 25.5,0 C39.5834422,0 51,11.4167022 51,25.500093",
    id: "Stroke-1",
    stroke: "#212457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,8 L26,11.1854732 M13.2722661,13.2719178 L15.5248027,15.5242783 M8,26.000094 L11.1854566,26.000094 M13.2722661,38.7278943 L15.5248027,36.4755338 M26,44 L26,40.8145268 M44,26.000094 L40.8145434,26.000094 M38.7277339,13.2719178 L36.4753852,15.5242783",
    id: "Stroke-3",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(35.000000, 31.000000)",
    stroke: "#212457"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0944625,22.5650918 L26.88615,22.5650918 C28.514775,22.5650918 29.8349625,21.22071 29.8349625,19.5628555 C29.8349625,17.90481 28.514775,16.5606191 26.88615,16.5606191 L26.0289,16.5606191",
    id: "Stroke-4",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00601875,15.2540564 C0.00601875,20.4265473 2.91770625,24.90642 7.16308125,27.0877473 L18.8718937,27.0877473 C23.1172687,24.90642 26.0289562,20.4265473 26.0289562,15.2540564 L0.00601875,15.2540564 Z M13.2131437,11.7686291 C13.1981437,11.7430473 11.7101438,9.21216545 12.9035813,6.76261091 C14.6105812,3.25981091 12.6281437,0.222638182 12.5426437,0.0951109091 L13.2131437,11.7686291 Z M6.43351875,2.15082 C6.44514375,2.16819273 7.59770625,3.93429273 6.60826875,5.96422909 C5.18870625,8.87845636 6.87358125,11.74782 6.94576875,11.8684745 L6.43351875,2.15082 Z M19.4178937,2.15082 C19.4295187,2.16819273 20.5820813,3.93429273 19.5926437,5.96422909 C18.1730812,8.87845636 19.8579562,11.74782 19.9301437,11.8684745 L19.4178937,2.15082 Z",
    id: "Stroke-6"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.ca6ca361.svg";
export { ForwardRef as ReactComponent };